import React, { Component, Fragment } from 'react';
import {
    View,
    ScrollView,
    FlatList,
    ActivityIndicator,
    TouchableOpacity,
    Dimensions
} from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';

import { Creators as toastActions } from '../../store/ducks/toast';
import { Creators as produtosActions } from '../../store/ducks/produtos';
import { Creators as produtoSelecionadoActions } from '../../store/ducks/produto-selecionado';
import { Creators as departamentoSelecionadoActions } from '../../store/ducks/departamento-selecionado';

import HeaderBar from '../../react-component/headerBar';
import Text from '../../react-component/textComponent';
import Pagination from '../../react-component/pagination';
import Modal from '../../react-component/modal';
import ButtonLoading from '../../react-component/buttonLoading';
import ButtonFiltro from '../../react-component/buttonFiltro';
import ModalFiltro from '../../react-component/modalFiltro';

import createEmptyItems from '../../config/createEmptyItems';

import ProdutoWrapper from '../../screens/produtoWrapper';
import styles from './styles';
import AvisoSincronizacao from '../avisoSincronizacao';
import ItemLista from './itemLista';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

import { changeProdutoDisponibilidade } from './api';
import { PLANOS } from '../../constants/planos';
import { Tooltip } from '@mui/material';

const { width } = Dimensions.get('window');

import { Add, Edit, RadioButtonChecked, RadioButtonUnchecked, Visibility } from '@mui/icons-material';

const NUM_COLUMNS = isMobile ? 2 : Math.floor(width / 320);

const DISP = {
    automatico: { id: 1, name: 'Automático' },
    indisponivel: { id: 2, name: 'Indisponível' },
    disponivel: { id: 3, name: 'Disponível' }
};

class DepartamentoDetalhe extends Component {
    state = {
        page: 1,
        limit: 200,
        hasNext: true,
        loading: true,
        modalTitle: '',
        modalDisponibilidadeIsOpen: false,
        modalCadastroProdutoIsOpen: false,
        modalFiltroIsOpen: false,
        disponibilidade: {},
        query: '',
        filtroAtual: ['todos'],
        disponibilidadeAtual: {}
    };

    componentDidMount() {
        if (!Layout.isDesktop) {
            const { departamentoSelecionado } = this.props,
                { idDepartamento } = departamentoSelecionado,
                newState = {
                    idDepartamento,
                    page: 1,
                    hasNext: true,
                    loading: true
                };

            this.setState(newState, () => {
                this.loadProdutoDepartamento();
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { idDepartamento, query } = this.props;

        if (
            idDepartamento &&
            (idDepartamento !== prevProps.idDepartamento ||
                query !== prevProps.query)
        ) {
            const newState = {
                idDepartamento: idDepartamento || prevProps.idDepartamento,
                page: 1,
                hasNext: true,
                loading: true,
                filtroAtual: ['todos']
            };

            this.setState(newState, () => {
                this.loadProdutoDepartamento();
            });
        }
    }

    loadProdutoDepartamento = async () => {
        const {
                query = '',
                searchProdutos,
                departamentoSelecionado
            } = this.props,
            { idDepartamento } = departamentoSelecionado,
            { limit = 100, page, filtroAtual } = this.state,
            params = {
                page,
                limit,
                filter: filtroAtual[0],
                search: query
            };

        if (idDepartamento) {
            await searchProdutos({ idDepartamento, params });

            const { produtos } = this.props,
                { list = {} } = produtos,
                { data = {} } = list || {};

            this.setState({
                idDepartamento,
                hasNext: data.hasNext || false,
                loading: false
            });
        }
    };

    renderFooter = () => {
        if (!this.state.loading) return null;

        return (
            <View style={styles.loading}>
                <ActivityIndicator />
            </View>
        );
    };

    pageChange = (page) => {
        this.setState({ ...this.state, page, loading: true }, () => {
            this.loadProdutoDepartamento();
        });
    };

    buttonAction = (Icon, action, isDisabled = false) => {
        const iconStyle = isDisabled ? Colors.light : Colors.secondary;

        return (
            <Fragment>
                <button
                    onClick={action}
                    style={{
                        cursor: 'pointer',
                        backgroundColor: Colors.lighter,
                        padding: Layout.gutterMedium,
                        borderRadius: 100,
                        borderWidth: 1,
                        borderStyle: 'solid',
                        borderColor: Colors.border
                    }}
                    disabled={isDisabled}
                >
                    <Icon sx={{
                        fontSize: 24,
                        color: iconStyle 
                     }} 
                    />
                </button>
            </Fragment>
        );
    };

    showActions = () => {
        const { produtoSelecionado } = this.props,
            multiplosProdutos =
                produtoSelecionado && produtoSelecionado.length > 1,
            disableEdit = multiplosProdutos;

        return (
            <View style={styles.flexRow}>
                <View
                    style={{
                        marginRight: Layout.gutter
                    }}
                >
                    {this.callTooltip(
                        this.buttonAction(
                            Visibility,
                            this.changeDisponibilidade
                        ),
                        'Disponibilidade'
                    )}
                </View>

                <View
                    style={{
                        marginRight: Layout.gutter
                    }}
                >
                    {this.callTooltip(
                        !isMobile &&
                            this.buttonAction(
                                Edit,
                                this.openEdicaoProduto,
                                disableEdit
                            ),
                        'Editar',
                        !disableEdit
                    )}
                </View>

                {/* {this.buttonAction('tag', this.showDetails)} */}
            </View>
        );
    };

    showDetails = () => {
        this.setState({
            ...this.state
        });
    };

    openEdicaoProduto = () => {
        const { produtoSelecionado } = this.props;

        let produto = {};

        if (produtoSelecionado && produtoSelecionado.length === 1) {
            produto = produtoSelecionado[0];
        }

        this.setState({
            ...this.state,
            modalCadastroProdutoIsOpen: true,
            produto
        });
    };

    openCadastroProduto = () => {
        const { idDepartamento } = this.props;

        this.setState({
            ...this.state,
            modalCadastroProdutoIsOpen: true,
            produto: { idDepartamento }
        });
    };

    callFiltroModal = () => {
        const { modalFiltroIsOpen } = this.state,
            buttonFiltro = document.getElementById('filtro'),
            buttonProps = buttonFiltro.getBoundingClientRect(),
            filtroPosX = buttonProps.x,
            filtroPosY = buttonProps.y;

        this.setState({
            modalFiltroIsOpen: !modalFiltroIsOpen,
            filtroPosX,
            filtroPosY
        });
    };

    changeFiltro = (filtro) => {
        const { filtroAtual, modalFiltroIsOpen } = this.state;

        let novoFiltro = [];

        if (filtro === 'promocao') {
            novoFiltro = filtroAtual[1]
                ? [filtroAtual[0]]
                : [filtroAtual[0], filtro];
        } else if (filtroAtual[1]) {
            novoFiltro = [filtro, filtroAtual[1]];
        } else {
            novoFiltro = [filtro];
        }

        this.setState(
            {
                ...this.state,
                filtroAtual: novoFiltro,
                loading: true,
                page: 1,
                modalFiltroIsOpen: !modalFiltroIsOpen
            },
            () => {
                this.loadProdutoDepartamento();
            }
        );
    };

    radioItemChanged = (disponibilidade) => {
        this.setState({
            ...this.state,
            disponibilidade
        });
    };

    callTooltip = (obj, message, showTooltip = true) => {
        if (!isMobile && showTooltip) {
            return (
                <Tooltip title={
                    <div
                        style={{
                            fontSize: '1.6rem',
                            fontFamily: 'NunitoSans-Regular'
                        }}
                    >
                        {message}
                    </div>
                  } 
                placement='bottom'>
                    <div>{obj}</div>
                </Tooltip>
            );
        } else {
            return <div>{obj}</div>;
        }
    };

    changeDisponibilidade = async () => {
        const { produtoSelecionado } = this.props;

        var sameIds = true,
            dispAtualId;

        let tpDisponivel = 1,
            disponibilidade = {};

        if (produtoSelecionado.length === 1) {
            if (produtoSelecionado[0].tpDisponivel === 0) {
                dispAtualId = 1;
            } else {
                dispAtualId = produtoSelecionado[0].tpDisponivel;
            }
        } else {
            const { tpDisponivel } = produtoSelecionado[0],
                stId = tpDisponivel;

            for (var i = 1; i < produtoSelecionado.length; i++) {
                let { tpDisponivel } = produtoSelecionado[i];

                if (JSON.stringify(tpDisponivel) !== JSON.stringify(stId)) {
                    sameIds = false;
                    break;
                } else {
                    sameIds = true;
                }
            }
        }

        if (produtoSelecionado.length === 1 || sameIds === true) {
            tpDisponivel = produtoSelecionado[0].tpDisponivel || 1;

            [disponibilidade] = Object.values(DISP).filter(
                (disp) => disp.id === tpDisponivel
            );
        }

        this.setState({
            ...this.state,
            modalTitle: 'Disponibilidade no Cestou',
            disponibilidade,
            disponibilidadeAtual: {
                idAtual: dispAtualId || 0,
                sameIds: sameIds
            },
            modalDisponibilidadeIsOpen: true
        });
    };

    renderHeader = () => {
        const {
                departamentoSelecionado,
                produtoSelecionado,
                produtos,
                query,
                user
            } = this.props,
            { idDepartamento } = departamentoSelecionado,
            { list = {} } = produtos,
            { data = {} } = list,
            departamento = data.data || {},
            dsDepartamento = query || departamento.dsDepartamento,
            showActions = produtoSelecionado.length > 0,
            { plano = {} } = user,
            { idPlano = 1 } = plano,
            cadastroDisponivel = idPlano === PLANOS.STANDARD && !isMobile,
            hasDescricao = dsDepartamento && dsDepartamento.length > 12,
            { filtroAtual, modalFiltroIsOpen } = this.state,
            title = isMobile
                ? hasDescricao
                    ? dsDepartamento.substring(0, 12) + '...'
                    : dsDepartamento
                : dsDepartamento;

        const addProdutoText = () => (
            <View style={styles.addProdutoButton}>
                <Add sx={{
                    fontSize: 20,
                    color: Colors.white
                 }}
                />
                <Text style={{ color: Colors.white }}> Produto</Text>
            </View>
        );

        return (
            <View style={styles.pageHeader}>
                <View style={styles.actionsContainer}>
                    {idDepartamento ? (
                        <Fragment>
                            <Text $bold style={styles.pageTitle}>
                                {title}
                            </Text>
                        </Fragment>
                    ) : (
                        <Fragment>
                            {!Layout.isDesktop && (
                                <Text $bold style={styles.pageTitle}>
                                    Voltar
                                </Text>
                            )}
                        </Fragment>
                    )}
                </View>

                <View style={styles.buttonContainer}>
                    {showActions && this.showActions()}

                    {Layout.isDesktop && (
                        <div id="filtro">
                            <ButtonFiltro
                                filtroAtual={filtroAtual}
                                style={styles.buttonFiltro}
                                onPress={() => this.callFiltroModal()}
                                isOpen={modalFiltroIsOpen}
                            />
                        </div>
                    )}

                    {cadastroDisponivel && (
                        <ButtonLoading
                            label={addProdutoText()}
                            style={styles.buttonCadastro}
                            onPress={() => this.openCadastroProduto()}
                        />
                    )}
                </View>
            </View>
        );
    };

    removeDepartamentoStore = () => {
        const { deselectDepartamento } = this.props;
        this.props.clearSearchQuery();

        deselectDepartamento();
    };

    renderList = () => {
        const { navigation, produtos, departamentoSelecionado } = this.props,
            { idDepartamento } = departamentoSelecionado,
            { list = {} } = produtos,
            { data = {} } = list,
            { itens = [], countProdutos } = data.data || {},
            { limit } = this.state,
            formattedList = createEmptyItems(itens, NUM_COLUMNS);

        return (
            <View style={styles.container}>
                <HeaderBar
                    navigation={navigation}
                    hasBack={this.props.hasBack || false}
                    returnCallback={this.removeDepartamentoStore}
                    style={styles.headerBar}
                >
                    {this.renderHeader()}
                </HeaderBar>

                {idDepartamento && formattedList && formattedList.length ? (
                    <Fragment>
                        <AvisoSincronizacao />
                        <ScrollView>
                            <FlatList
                                data={formattedList}
                                contentContainerStyle={styles.listContent}
                                renderItem={({ item }) => (
                                    <ItemLista
                                        numColumns={NUM_COLUMNS}
                                        item={item}
                                    />
                                )}
                                ListFooterComponent={this.renderFooter}
                                keyExtractor={(item, index) =>
                                    `departamento-produto-${item.idDepartamento}-${index}`
                                }
                                numColumns={NUM_COLUMNS}
                            />
                        </ScrollView>
                        <View>
                            <Pagination
                                currentPage={this.state.page}
                                totalRecords={countProdutos}
                                pageLimit={limit}
                                pageNeighbours={1}
                                onPageChange={this.pageChange}
                            />
                        </View>
                    </Fragment>
                ) : (
                    <View style={styles.loading}>
                        <ActivityIndicator
                            style={styles.loading}
                            size="large"
                        />
                    </View>
                )}
            </View>
        );
    };

    checkOptionAutomatico = () => {
        const { user } = this.props,
            { plano = {} } = user,
            { idPlano } = plano;

        if (idPlano !== 1) {
            return this.renderRadioButton(DISP.automatico);
        }
    };

    checkHasOptionAutomatico = () => {
        const { user } = this.props,
            { plano = {} } = user,
            { idPlano } = plano;

        return idPlano !== 1;
    };

    closeModal = () => {
        const { disponibilidade, disponibilidadeAtual } = this.state,
            { idAtual, sameIds } = disponibilidadeAtual,
            { id } = disponibilidade,
            { clearProdutoSelecionado, produtoSelecionado } = this.props;
        var dispAtualId;

        if (sameIds === true) {
            dispAtualId = idAtual || produtoSelecionado[0].tpDisponivel;
        } else {
            dispAtualId = 0;
        }

        if (id && id !== dispAtualId) {
            let confirm = window.confirm(`Cancelar edição de disponibilidade?`);
            if (confirm) {
            } else {
                return;
            }
        }

        clearProdutoSelecionado();

        this.setState({
            ...this.state,
            modalDisponibilidadeIsOpen: false,
            modalCadastroProdutoIsOpen: false,
            produto: {}
        });
    };

    modalClosed = () => {
        const { clearProdutoSelecionado } = this.props;

        clearProdutoSelecionado();
        this.setState({
            ...this.state,
            modalDisponibilidadeIsOpen: false,
            modalCadastroProdutoIsOpen: false,
            produto: {}
        });
    };

    saveProdutoDisponibilidade = async () => {
        const { addToast, produtoSelecionado, clearProdutoSelecionado } =
                this.props,
            idsProdutos = produtoSelecionado.map(({ idProduto }) => {
                return { idProduto };
            }),
            { disponibilidade } = this.state,
            { id } = disponibilidade;

        const request = await changeProdutoDisponibilidade(idsProdutos, id),
            message = request.message;

        this.setState(
            { ...this.state, modalDisponibilidadeIsOpen: false },
            () => {
                addToast({
                    text: message,
                    more: 'OK',
                    theme: 'success'
                });
            }
        );

        const { searchProdutos, departamentoSelecionado } = this.props,
            { idDepartamento, query } = departamentoSelecionado,
            { limit = 100, page } = this.state,
            params = {
                page,
                limit,
                search: query
            };

        await searchProdutos({ idDepartamento, params });

        clearProdutoSelecionado();
    };

    renderRadioButton = (disp, isDisabled = false) => {
        const { disponibilidade = {} } = this.state,
            textStyle = [
                styles.radioButtonLabel,
                isDisabled ? { color: Colors.light } : {}
            ];

        return (
            <View style={styles.radioButtonContainer}>
                <TouchableOpacity
                    style={styles.flexRow}
                    onPress={() => this.radioItemChanged(disp)}
                    disabled={isDisabled}
                >
                    {isDisabled ? (
                        <RadioButtonUnchecked
                            sx={{
                                fontSize: 22,
                                color: Colors.light 
                            }}
                            style={styles.radioButtonIcon}
                        />
                    ) : (
                        
                         disponibilidade.id === disp.id 
                            ? <RadioButtonChecked 
                                sx={{
                                    fontSize: 22,
                                    color: Colors.secondary
                                }} 
                                style={styles.radioButtonIcon} 
                            /> 
                            : <RadioButtonUnchecked 
                                sx={{
                                    fontSize: 22,
                                    color: Colors.secondary
                                }} 
                                style={styles.radioButtonIcon} 
                            />
                    )}
                    <Text style={textStyle}>{disp.name}</Text>
                </TouchableOpacity>
            </View>
        );
    };

    render() {
        const {
            modalDisponibilidadeIsOpen,
            modalCadastroProdutoIsOpen,
            modalFiltroIsOpen,
            produto = {},
            modalTitle,
            filtroPosY,
            filtroPosX,
            filtroAtual
        } = this.state;

        return (
            <Fragment>
                {this.renderList()}
                {modalDisponibilidadeIsOpen && (
                    <Modal
                        size="normalSmall"
                        title={modalTitle}
                        isOpen={modalDisponibilidadeIsOpen}
                        onClose={this.closeModal}
                        onSave={this.saveProdutoDisponibilidade}
                        saveText="Salvar"
                    >
                        <div>
                            {this.renderRadioButton(DISP.disponivel)}
                            {this.renderRadioButton(DISP.indisponivel)}
                            {this.checkOptionAutomatico()}
                        </div>
                    </Modal>
                )}

                {modalFiltroIsOpen && (
                    <ModalFiltro
                        filtroAtual={filtroAtual}
                        isOpen={modalFiltroIsOpen}
                        onClose={this.callFiltroModal}
                        changeFiltro={this.changeFiltro}
                        left={filtroPosX}
                        top={filtroPosY}
                    />
                )}

                {modalCadastroProdutoIsOpen && (
                    <ProdutoWrapper
                        loadDepartamentoList={this.props.loadDepartamentoList}
                        onClose={this.modalClosed}
                        produto={produto}
                    />
                )}
            </Fragment>
        );
    }
}

const mapStateToProps = ({
    departamentoSelecionado,
    produtoSelecionado,
    produtos,
    user
}) => ({
    departamentoSelecionado,
    produtoSelecionado,
    produtos,
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...toastActions,
            ...produtosActions,
            ...produtoSelecionadoActions,
            ...departamentoSelecionadoActions
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartamentoDetalhe);
